import React from 'react'
import { useIntl } from 'react-intl'
import { TableRow } from '@mui/material'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'

function AnswerFlagTableHeader(): React.ReactElement {
  const { formatMessage } = useIntl()

  return (
    <TableRow>
      <TableHeaderCell label={formatMessage({ id: 'answerFlagRule.title' })} />
      <TableHeaderCell label={formatMessage({ id: 'answerFlagRule.segmentation' })} />
      <TableHeaderCell
        align="right"
        minWidth={TableCellWidth.SMALL}
        label={formatMessage({ id: 'answerFlagRule.riskSeverity' })}
      />
      <TableHeaderCell
        align="right"
        minWidth={TableCellWidth.SMALL}
        label={formatMessage({ id: 'resourceCollections.general.action' })}
      />
    </TableRow>
  )
}

export default AnswerFlagTableHeader
